/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown> }} Directory_Hubs_Legend_RankInputs */

const en_directory_hubs_legend_rank = /** @type {(inputs: Directory_Hubs_Legend_RankInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Legend #${i?.rank}`)
};

const zh_directory_hubs_legend_rank = /** @type {(inputs: Directory_Hubs_Legend_RankInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`传奇第 ${i?.rank} 名`)
};

/**
* | output |
* | --- |
* | "Legend #{rank}" |
*
* @param {Directory_Hubs_Legend_RankInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_legend_rank = /** @type {((inputs: Directory_Hubs_Legend_RankInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Legend_RankInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_legend_rank(inputs)
	return zh_directory_hubs_legend_rank(inputs)
});
export { directory_hubs_legend_rank as "directory.hubs.legend_rank" }